<script lang="ts">
  // Counted two-way split (solid, party colours) with the model's estimated final result overlaid in purple:
  // a hatched band for the 90% range and a diamond at the median. Left = pair[0] (positive margin).
  import type { ChoiceSummary, Interval } from '../../types';
  import { colorVar } from '../../lib/race';
  let { left, right, margin = null, height = 14 }: { left: ChoiceSummary; right: ChoiceSummary; margin?: Interval | null; height?: number } = $props();
  const tot = $derived(left.pct + right.pct);
  const lw = $derived(tot > 0 ? (100 * left.pct) / tot : 50);
  /** nothing counted yet: a neutral empty track, not a 50/50 split */
  const empty = $derived(left.votes + right.votes === 0);
  const x = (m: number) => Math.max(0, Math.min(100, 50 + m / 2));
</script>

<div class="sb" style="--h:{height}px" role="img"
  aria-label={empty ? 'No votes counted yet' : `Counted: ${left.name} ${left.pct.toFixed(1)}%, ${right.name} ${right.pct.toFixed(1)}%${margin ? '. Estimate shown in purple.' : ''}`}>
  <div class="bar" class:empty>
    {#if !empty}
      <span class="l" style="width:{lw}%;background:{colorVar(left)}"></span>
      <span class="r" style="width:{100 - lw}%;background:{colorVar(right)}"></span>
    {/if}
    {#if margin}
      <span class="band" style="left:{x(margin.lo90)}%;width:{Math.max(0.8, x(margin.hi90) - x(margin.lo90))}%"></span>
    {/if}
  </div>
  <span class="mid" aria-hidden="true"></span>
  {#if margin}<span class="dia" style="left:{x(margin.median)}%" aria-hidden="true"></span>{/if}
</div>

<style>
  .sb { position: relative; padding: 5px 0; }
  .bar { position: relative; display: flex; height: var(--h); border-radius: 999px; overflow: hidden; gap: 2px; background: var(--card); }
  .bar.empty { background: var(--card-3); }
  .l, .r { display: block; height: 100%; transition: width var(--t-med) ease; }
  .l { border-radius: 999px 0 0 999px; }
  .r { border-radius: 0 999px 999px 0; }
  .band { position: absolute; top: 0; bottom: 0; background: repeating-linear-gradient(135deg, var(--hatch) 0 2px, transparent 2px 5px); box-shadow: inset 0 0 0 1.5px var(--est); border-radius: 3px; transition: left var(--t-med), width var(--t-med); }
  .mid { position: absolute; left: 50%; top: 0; bottom: 0; width: 2px; margin-left: -1px; background: var(--ink); opacity: 0.55; border-radius: 1px; }
  .dia { position: absolute; top: 50%; width: 12px; height: 12px; margin: -6px 0 0 -6px; background: var(--est); transform: rotate(45deg); border-radius: 2px; box-shadow: 0 0 0 2px var(--card); transition: left var(--t-med); }
</style>
